<script>
  import {createEventDispatcher} from 'svelte';
  import {goto} from '@sapper/app';
  import Modal from '@/widgets/Modal.svelte';
  import {is_JP_KR$, kycSummary$} from '@/modules/account/overview/stream-kyc';
  import {IMAGES_NEWS, PATHS} from '@/const';
  import Button from '@/widgets/Button.svelte';
  import {fixLink$} from '@/store/lang';
  import lang from './NoticeDialog.lang';

  export let LG = null;

  const dispatcher = createEventDispatcher();

  $: isNewUser = $kycSummary$.kycFlag === 1;

  function handleClose() {
    dispatcher('close');
  }

  function handleClickStop(e) {
    e.stopPropagation();
  }

  function handleConfirmClick() {
    goto($fixLink$(PATHS.ACCOUNT_VERIFICATION.pathname) + `?type=jumio`);
  }
</script>

<style>
</style>

<div class="dialog-box" on:mousewheel|preventDefault>
  <Modal visible allowScroll showCloseIcon on:close={handleClose} style="border-radius: 12px;width: 480px;background: #fff;">
    <div class="tc">
      <img width="100" height="100" src={IMAGES_NEWS.KYC_CERTIFICATION} class="kyc tc" alt="KYC" />
      <h2 class="p0 mb24 tc">{LG(lang.TradingRequirements)}</h2>
      <div class="df fdc aic" on:click={handleClickStop}>
        <div class="df fdc">
          <div class="lh24 f16 T3">
            {@html LG(lang.ForSecureTransactions).replace(
              LG(lang.BasicAndAdv),
              isNewUser && !$is_JP_KR$ ? `<span class="T1">${LG(lang.IdentityVerification)}</span>` : `<span class="T1">${LG(lang.BasicAndAdv)}</span>`
            )}
          </div>
          <div class="mt10 lh24 f16 T1 tl">{LG(lang.NoteTheOriginal)}</div>
        </div>
        <div class="mt40 wp100">
          <Button class="wp100" newRadius type="primary" on:click={handleConfirmClick}>{LG(lang.Confirm)}</Button>
        </div>
      </div>
    </div>
  </Modal>
</div>
